<div class="row p-1 logo-info">
  <span translate="FileUploadHelper.Formats"></span>&nbsp;
  <strong>{{ acceptedExtensions }}</strong>
</div>
<div class="row p-1 logo-info">
  <br>
    <span translate="FileUploadHelper.Size"></span>&nbsp;
    <strong>{{maxSize.size}} <label translate="FileUploadHelper.{{maxSize.unit}}"></label></strong>
  </div>
  @if (maxResolution.width>0 && maxResolution.height>0) {
    <div class="row p-1 logo-info">
      <br>
        <span translate="FileUploadHelper.Resolution"></span>&nbsp;
        <strong>{{maxResolution.width}}x{{maxResolution.height}}px</strong>
      </div>
    }
